import * as SliderPrimitive from "@radix-ui/react-slider";
import * as React from "react";

import { cn } from "../utils";

type SliderProps = React.ComponentProps<typeof SliderPrimitive.Root> & {
  displayLabels?: boolean;
};

function Slider({ className, defaultValue, displayLabels = false, value, min = 0, max = 100, ...props }: SliderProps) {
  const _values = React.useMemo(
    () => (Array.isArray(value) ? value : Array.isArray(defaultValue) ? defaultValue : [min, max]),
    [value, defaultValue, min, max]
  );

  return (
    <SliderPrimitive.Root
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      className={cn(
        "relative flex w-full touch-none select-none items-center data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50",
        displayLabels && "pb-5",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track className={cn("relative h-0.75 w-full grow rounded-full bg-input")}>
        <SliderPrimitive.Range className={cn("absolute h-full bg-primary")} />
      </SliderPrimitive.Track>
      {_values.map((v, index) => (
        <SliderPrimitive.Thumb
          key={index}
          className="block size-4 relative rounded-full border-[2.5px] border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
        >
          {displayLabels && (
            <span className="absolute font-semibold left-1/2 mt-1 text-2xs text-muted-foreground top-full -translate-x-1/2">
              {v}
            </span>
          )}
        </SliderPrimitive.Thumb>
      ))}
    </SliderPrimitive.Root>
  );
}

export { Slider };
